import type { Persona } from "@/types/api/Persona"

import { resolvePersonaLanguage } from "../components/persona-utils"

// Value the active sort compares on, by column id. Language sorts by its
// displayed label (not the raw code) to match the column cell; the timestamp
// columns compare their ISO strings, which order chronologically.
export const getPersonaSortValue = (
  persona: Persona,
  columnId: string,
): string => {
  switch (columnId) {
    case "language":
      return resolvePersonaLanguage(persona)
    case "simulated_user_prompt":
      return persona.simulated_user_prompt ?? ""
    case "last_updated_at":
      return persona.attribution?.updated_at ?? ""
    case "created_at":
      return persona.attribution?.created_at ?? ""
    case "id":
      return persona.id
    case "display_name":
    default:
      return persona.display_name ?? ""
  }
}
